var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1193 0 0 1.1193 -1.4315 -2.5508)",
    clipPath: "url(#a)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 7.5c-4.3048 0-7.5238 3.5833-8.6053 4.9653-0.24878 0.3179-0.24878 0.7515 0 1.0694 1.0814 1.382 4.3004 4.9653 8.6053 4.9653 4.3048 0 7.5238-3.5833 8.6053-4.9653 0.2488-0.3179 0.2488-0.7515 0-1.0694-1.0815-1.382-4.3005-4.9653-8.6053-4.9653z",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.28febb020fa9372e5c1fe37bcd7e2367.svg";
export { ForwardRef as ReactComponent };